import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { catchError } from 'rxjs/operators';

import { LzLanguageService } from '../lz-language/lz-language.service';
import { ErrorLogService } from '../error-log/error-log.service';

declare var Fingerprint: any;

@Injectable()

export class CustomRequestService {

   private lang: string;
   private rnd: string;
   private fingerprint: string;
   private headers: HttpHeaders = new HttpHeaders();

   constructor(private http: HttpClient, private language: LzLanguageService, private log: ErrorLogService) {
      this.lang = this.language.identifyLanguage();

      try {
         this.fingerprint = new Fingerprint({
            screen_resolution: true
         }).get();
      } catch (e) {
         this.fingerprint = '';
      }

      this.rnd = '' + (+new Date() + '.' + this.fingerprint);

      this.headers = this.headers
         .set('Content-Type', 'application/json; charset=utf-8')
         .set('Accept-Language', this.lang)
         .set('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT')
         .set('Cache-Control', 'no-cache, no-store, must-revalidate')
         .set('Pragma', 'no-cache');
   }

   /**
    * @param url - request url : string
    * @param parameters - query params that will be added to url : Object
    * @param heads : - custom headers that will be added to request Object
    * @param responseType : type of response
    */
   public getRequest(url: string, parameters?: Object, heads?: Object, responseType?): any {
      const queryParams = {};

      if (parameters) {
         for (const prop in parameters) {
            if (parameters.hasOwnProperty(prop)) {
               if (parameters[prop] !== null && typeof parameters[prop] === 'object') {
                  queryParams[prop] = JSON.stringify(parameters[prop]);
               } else {
                  queryParams[prop] = parameters[prop];
               }
            }
         }
      }

      if (heads) {
         for (const prop in heads) {
            if (heads.hasOwnProperty(prop)) {
               this.headers = this.headers.set(prop, heads[prop]);
            }
         }
      }

      queryParams['rnd'] = this.rnd;

      return this.http.get(url, {
         headers: this.headers,
         params: queryParams,
         responseType: (responseType !== undefined) ? responseType : "json",
         withCredentials: true
      }).pipe(catchError((error, caught): any => {
            let errorData = {
                  'status': (error.status) ? error.status : 'undefined',
                  'url': (error.url) ? error.url : 'undefined',
                  'params': '',
                  'host': window.location.host,
                  'href': window.location.href
            };
            this.log.errorLogForSpark(errorData);
            console.log("ERROR_INFO: ", error);
            throw error;
      }));
   }

   /**
    * @param url - request url : string
    */
   public deleteRequest(url: string): any {
      const queryParams = {};

      queryParams['rnd'] = this.rnd;

      return this.http.delete(url, {
         headers: this.headers,
         params: queryParams,
         withCredentials: true
      }).pipe(catchError((error, caught): any => {
            let errorData = {
                  'status': (error.status) ? error.status : 'undefined',
                  'url': (error.url) ? error.url : 'undefined',
                  'params': '',
                  'host': window.location.host,
                  'href': window.location.href
            };
            this.log.errorLogForSpark(errorData);
            console.log("ERROR_INFO: ", error);
            throw error;
      }));
   }

   /**
    * @param url - request url : string
    * @param body - request body : Object
    * @param parameters - query params that will be added to url : Object
    * @param heads : - custom headers that will be added to request Object
    */
   public postRequest(url: string, body?: Object, parameters?: Object, heads?: Object): any {

      const params = {};
      const queryParams = {};

      if (body) {
         for (const prop in body) {
            if (body.hasOwnProperty(prop)) {
               params[prop] = body[prop];
            }
         }
      }

      if (parameters) {
         for (const prop in parameters) {
            if (parameters.hasOwnProperty(prop)) {
               queryParams[prop] = parameters[prop];
            }
         }
      }

      if (heads) {
         for (const prop in heads) {
            if (heads.hasOwnProperty(prop)) {
               this.headers = this.headers.set(prop, heads[prop]);
            }
         }
      }

      queryParams['rnd'] = this.rnd;

      return this.http.post(url, params, {
         headers: this.headers,
         params: queryParams,
         withCredentials: true
      }).pipe(catchError((error, caught): any => {
            let errorData = {
                  'status': (error.status) ? error.status : 'undefined',
                  'url': (error.url) ? error.url : 'undefined',
                  'params': '',
                  'host': window.location.host,
                  'href': window.location.href
            };
            this.log.errorLogForSpark(errorData);
            console.log("ERROR_INFO: ", error);
            throw error;
      }));
   }

   /**
    * @param url - request url : string
    * @param body - request body : Object
    * @param parameters - query params that will be added to url : Object
    * @param heads : - custom headers that will be added to request Object
    */
   public postRequestWithFormData(url: string, body?: Object, parameters?: Object, heads?: Object): any {

      const queryParams = {};

      let params = '';
      let hdrs = this.headers;

      if (body) {
         for (const prop in body) {
            if (body.hasOwnProperty(prop)) {
               params += prop + '=' + body[prop] + '&';
            }
         }
         params = params.substring(0, params.length - 1);
      }

      if (parameters) {
         for (const prop in parameters) {
            if (parameters.hasOwnProperty(prop)) {
               queryParams[prop] = parameters[prop];
            }
         }
      }

      if (heads) {
         for (const prop in heads) {
            if (heads.hasOwnProperty(prop)) {
               hdrs = hdrs.set(prop, heads[prop]);
            }
         }
      }

      queryParams['rnd'] = this.rnd;

      return this.http.post(url, params, {
         headers: hdrs,
         params: queryParams,
         withCredentials: true
      }).pipe(catchError((error, caught): any => {
            let errorData = {
                  'status': (error.status) ? error.status : 'undefined',
                  'url': (error.url) ? error.url : 'undefined',
                  'params': '',
                  'host': window.location.host,
                  'href': window.location.href
            };
            this.log.errorLogForSpark(errorData);
            console.log("ERROR_INFO: ", error);
            throw error;
      }));
   }

}
